module.exports = __webpack_public_path__ + "static/media/windChimes2.b7a26360.mp3";